// Multivariate Dependencies
import React from 'react';
// Components
import { Container } from '../../../common/styles/container';
import { Label } from '../../Label';
export var AvatarStructure = function (_a) {
    var className = _a.className, imageUrl = _a.imageUrl, imageAlt = _a.imageAlt, initials = _a.initials, onClick = _a.onClick;
    return (React.createElement(Container, { className: className, onClick: onClick }, imageUrl ? React.createElement("img", { src: imageUrl, alt: imageAlt }) : React.createElement(Label, { size: 'medium' }, initials)));
};
//# sourceMappingURL=AvatarStructure.js.map